import FeatureCommands from './FeatureCommands';

export default {
    init: (features, currentSiteUrl) => {
        if (!features) {
            return;
        }
        FeatureCommands.find(features, currentSiteUrl);
    },
    start: (feature, options, callbacks) => {
        FeatureCommands.process(feature, options, callbacks);
    },
    run: (feature, command, options) => {
        FeatureCommands.runCommand(feature, command, options);
    }
};
